import React from "react";
import { StyledFormElementsWrapper, ContainerGrid, FormLabel } from "../styles";
import { CustomFileUpload } from "../../../common/FormInputs";
import FormField from "../../../common/FormField/FormField";
import CustomSelect from "./CustomSelect";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

const UploadNotice = ({
  values,
  handleChange,
  errors,
  touched,
  handleBlur,
  setFieldValue,
  inputs,
  upload_templates,
  s3Upload,
  getFileName,
  menuItems,
}) => {
  return (
    <>
      <StyledFormElementsWrapper style={{ marginBottom: 8, marginTop: 15 }}>
        <SectionTitle>
          <SectionIcon>{"📄"}</SectionIcon>
          Create Notice Template
        </SectionTitle>

        <ContainerGrid className="disabledArrows">
          <CustomSelect
            name="partyId"
            value={values["partyId"]}
            trigger={false}
            {...{ errors, touched, setFieldValue, menuItems }}
          />
          {inputs.map((input, index) => (
            <FormField
              key={index}
              {...{
                touched,
                errors,
                input,
                values,
                handleChange,
                handleBlur,
                setFieldValue,
              }}
            />
          ))}
          {upload_templates.map((upload, index) => (
            <UploadBlock key={index}>
              <FormLabel>
                {upload.label}
                <span className="required-star"> *</span>
              </FormLabel>
              <CustomFileUpload
                error={touched[upload.name] && errors[upload.name]}
                setFile={(file) =>
                  s3Upload(file, upload.name, setFieldValue, upload.types)
                }
                style={{ width: "100%" }}
                accept={upload.accept}
                file={{ name: getFileName(values[upload.name]) }}
              />
            </UploadBlock>
          ))}
        </ContainerGrid>
      </StyledFormElementsWrapper>
    </>
  );
};

export default UploadNotice;

const SectionTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  font-weight: 700;
  color: ${COLORS.COLOR_DARK};
  margin-bottom: 24px;
  padding-bottom: 14px;
  border-bottom: 1.5px solid rgba(0, 131, 140, 0.1);
`;

const SectionIcon = styled.span`
  width: 32px;
  height: 32px;
  background: linear-gradient(
    135deg,
    rgba(0, 131, 140, 0.12),
    rgba(105, 227, 194, 0.15)
  );
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
`;

const UploadBlock = styled.div`
  margin-top: 10px;
`;
